import { render, staticRenderFns } from "./DeviceLayoutCity.vue?vue&type=template&id=62470dad&scoped=true"
import script from "./DeviceLayoutCity.vue?vue&type=script&lang=js"
export * from "./DeviceLayoutCity.vue?vue&type=script&lang=js"
import style0 from "./DeviceLayoutCity.vue?vue&type=style&index=0&id=62470dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62470dad",
  null
  
)

export default component.exports